import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
export default function scrollPositionDecorator(Wrapped) {
  return /*#__PURE__*/function (_React$Component) {
    function ScrollPosition() {
      var _this;
      _classCallCheck(this, ScrollPosition);
      _this = _callSuper(this, ScrollPosition, arguments);
      _this.state = {
        windowScrollX: 0,
        windowScrollY: 0
      };
      _this.updateScrollState = _this.updateScrollState.bind(_this);
      return _this;
    }
    _inherits(ScrollPosition, _React$Component);
    return _createClass(ScrollPosition, [{
      key: "updateScrollState",
      value: function updateScrollState() {
        this.setState({
          windowScrollX: window.scrollX,
          windowScrollY: window.scrollY
        });
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.updateScrollState();
        window.addEventListener('scroll', this.updateScrollState);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('scroll', this.updateScrollState);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Wrapped, _extends({}, this.props, {
          windowScrollX: this.state.windowScrollX,
          windowScrollY: this.state.windowScrollY
        }));
      }
    }]);
  }(React.Component);
}
//# sourceMappingURL=scrollPosition.js.map
